module.exports = __webpack_public_path__ + "static/media/R-360HD_CrossSection.341f1a53.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/fr/R-360HD_CrossSection.png
// module id = 497
// module chunks = 0